import React, { useState, useEffect } from "react";

import axios from "axios";

import LoaderPost from "../../../Reuseable/LoaderPost";

import MeetUpEventNave from "./MeetUpEventNave";
import AllModuleData from "../../../Reuseable/AllModuleData";

const MeetupContent = () => {
  const [event_data, setEvents] = useState([]);
  const [buffer, setBuffer] = useState(true);

  // Fetch Approved LiveChat
  useEffect(() => {
    axios.get(`/api/star/meetup_event/approved`).then((res) => {
      setBuffer(false);
      if (res.data.status === 200) {
        setEvents(res.data.events);
      }
    });
  }, []);

  return (
    <>
      <div className="AS">
        <MeetUpEventNave />

        {buffer ? (
          <LoaderPost />
        ) : (
          <>
            {" "}
            <div className="card card-bg head-line mb-2 mt-5">
              <div className="text-light d-flex justify-content-center p-2">
                <div className="faTrophy">
                  <i className="fas fa-trophy"></i>
                </div>
                <h4 className="mx-3 text-white p-2">
                  <span className="livechat-card-small">All MeetUp</span>
                </h4>
              </div>
            </div>
            <AllModuleData
              data={event_data}
              urlLink={`/superstar/meetup-events/details`}
            />
          </>
        )}
      </div>
    </>
  );
};

export default MeetupContent;
